import { finalRouteApi } from "./CommonApiUrl"


const artistDefaultURL = {
    listApi: `${finalRouteApi}/artist/index`,
    MultiDeleteApi: `${finalRouteApi}/artist/multi-delete`,
    createApi: `${finalRouteApi}/artist/create`,
    storeApi: `${finalRouteApi}/artist/store`,
    uploadImageApi: `${finalRouteApi}/artist/Image-upload-artist`,
    editApi: `${finalRouteApi}/artist/edit`,
    updateApi: `${finalRouteApi}/artist/update`,
    addRouteLink: `/add-artist`,
    editRouteLink: `/edit-artist/`,
    viewTab: 'artists',
    headingText: "All Artist",
    buttonText: "Add Artist",
    exportFileName: "ARTISTS-LIST",
    fetchArrayName: "AllArtist",
    reqBodyName: {
        deleteName: "id"
    }
}

const musicianDefaultURL = {
    listApi: `${finalRouteApi}/musician/index`,
    MultiDeleteApi: `${finalRouteApi}/musician/multi-delete`,
    createApi: `${finalRouteApi}/musician/create`,
    storeApi: `${finalRouteApi}/musician/store`,
    uploadImageApi: `${finalRouteApi}/Image-upload-musician`,
    editApi: `${finalRouteApi}/musician/edit`,
    updateApi: `${finalRouteApi}/musician/update`,
    addRouteLink: `/add-artist-musician`,
    editRouteLink: `/edit-artist-musician/`,
    viewTab: 'music/artist',
    headingText: "Manage Artist",
    buttonText: "Add Artist",
    exportFileName: "MUSICIAN-LIST",
    fetchArrayName: "AllArtist",
    reqBodyName: {
        deleteName: "id"
    }
}

export { artistDefaultURL, musicianDefaultURL }